module.exports = __webpack_public_path__ + "media/main_cards/point_on_map-27bbd88a.svg";